export default "__VITE_ASSET__94fd0008__"